/**
 * fitndex — Mock Data
 * All frontend data in Phase 1 comes from here.
 * Swap individual functions for real API calls when PHP backend is ready.
 */

// ── Exercise Library ─────────────────────────────────────────
export const EXERCISE_LIBRARY = [
  { id: 'ex-001', name: 'Barbell Back Squat',   category: 'Legs',       type: 'strength',   defaultWeight: 135, muscleGroups: ['Quads', 'Glutes', 'Hamstrings'] },
  { id: 'ex-002', name: 'Bench Press',           category: 'Push',       type: 'strength',   defaultWeight: 115, muscleGroups: ['Chest', 'Triceps', 'Shoulders'] },
  { id: 'ex-003', name: 'Deadlift',              category: 'Pull',       type: 'strength',   defaultWeight: 185, muscleGroups: ['Hamstrings', 'Back', 'Glutes'] },
  { id: 'ex-004', name: 'Pull-Up',               category: 'Pull',       type: 'bodyweight', defaultWeight: 0,   muscleGroups: ['Back', 'Biceps'] },
  { id: 'ex-005', name: 'Overhead Press',        category: 'Push',       type: 'strength',   defaultWeight: 75,  muscleGroups: ['Shoulders', 'Triceps'] },
  { id: 'ex-006', name: 'Romanian Deadlift',     category: 'Legs',       type: 'strength',   defaultWeight: 115, muscleGroups: ['Hamstrings', 'Glutes'] },
  { id: 'ex-007', name: 'Dumbbell Row',          category: 'Pull',       type: 'strength',   defaultWeight: 50,  muscleGroups: ['Back', 'Biceps'] },
  { id: 'ex-008', name: 'Bulgarian Split Squat', category: 'Legs',       type: 'strength',   defaultWeight: 45,  muscleGroups: ['Quads', 'Glutes'] },
  { id: 'ex-009', name: 'Push-Up',               category: 'Push',       type: 'bodyweight', defaultWeight: 0,   muscleGroups: ['Chest', 'Triceps'] },
  { id: 'ex-010', name: 'Plank',                 category: 'Core',       type: 'bodyweight', defaultWeight: 0,   muscleGroups: ['Core', 'Abs'] },
  { id: 'ex-011', name: 'Treadmill Run',         category: 'Cardio',     type: 'cardio',     defaultWeight: 0,   muscleGroups: ['Full Body'] },
  { id: 'ex-012', name: 'Rowing Machine',        category: 'Cardio',     type: 'cardio',     defaultWeight: 0,   muscleGroups: ['Back', 'Full Body'] },
  { id: 'ex-013', name: 'Box Jump',              category: 'Power',      type: 'bodyweight', defaultWeight: 0,   muscleGroups: ['Legs', 'Glutes'] },
  { id: 'ex-014', name: 'Kettlebell Swing',      category: 'Power',      type: 'mixed',      defaultWeight: 35,  muscleGroups: ['Glutes', 'Hamstrings', 'Core'] },
  { id: 'ex-015', name: 'Dips',                  category: 'Push',       type: 'bodyweight', defaultWeight: 0,   muscleGroups: ['Triceps', 'Chest'] },
  { id: 'ex-016', name: 'Leg Press',             category: 'Legs',       type: 'strength',   defaultWeight: 200, muscleGroups: ['Quads', 'Glutes'] },
  { id: 'ex-017', name: 'Cable Row',             category: 'Pull',       type: 'strength',   defaultWeight: 80,  muscleGroups: ['Back', 'Biceps'] },
  { id: 'ex-018', name: 'Face Pull',             category: 'Shoulders',  type: 'strength',   defaultWeight: 30,  muscleGroups: ['Rear Delts', 'Rotator Cuff'] },
];

// ── Mock Athletes (for coach view) ────────────────────────────
export const MOCK_ATHLETES = [
  { id: 'athlete-001', name: 'Jordan Lee',    avatar: null, position: 'Midfielder',  streak: 7,  lastActive: '2026-05-19' },
  { id: 'athlete-002', name: 'Sam Torres',    avatar: null, position: 'Forward',     streak: 3,  lastActive: '2026-05-20' },
  { id: 'athlete-003', name: 'Morgan Kim',    avatar: null, position: 'Goalkeeper',  streak: 12, lastActive: '2026-05-18' },
  { id: 'athlete-004', name: 'Casey Patel',   avatar: null, position: 'Defender',    streak: 1,  lastActive: '2026-05-20' },
  { id: 'athlete-005', name: 'Riley Chen',    avatar: null, position: 'Midfielder',  streak: 5,  lastActive: '2026-05-19' },
];

// ── Mock Workouts ─────────────────────────────────────────────
export const MOCK_WORKOUTS = [
  {
    id: 'wk-today',
    name: 'Full Body Activation',
    description: "Today's activation session — mobility, strength, and conditioning.",
    createdBy: 'coach-001',
    assignedTo: ['athlete-001', 'athlete-002', 'athlete-003', 'athlete-004', 'athlete-005'],
    scheduledDate: '2026-05-20',
    duration: 50,
    workOutputTarget: 2200,
    tags: ['full-body', 'activation'],
    exercises: [
      { exerciseId: 'ex-001', sets: 3, reps: 8,  weightLbs: 155, type: 'strength' },
      { exerciseId: 'ex-002', sets: 3, reps: 8,  weightLbs: 115, type: 'strength' },
      { exerciseId: 'ex-003', sets: 3, reps: 5,  weightLbs: 185, type: 'strength' },
      { exerciseId: 'ex-010', sets: 3, reps: 0,  weightLbs: 0, durationSec: 45, type: 'bodyweight' },
    ],
  },
  {
    id: 'wk-001',
    name: 'Lower Body Power',
    description: 'Squat-focused strength day with accessory work.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-001', 'athlete-003'],
    scheduledDate: '2026-05-21',
    duration: 60,
    workOutputTarget: 2400,
    tags: ['strength', 'lower'],
    exercises: [
      { exerciseId: 'ex-001', sets: 4, reps: 5,  weightLbs: 185, type: 'strength' },
      { exerciseId: 'ex-006', sets: 3, reps: 8,  weightLbs: 115, type: 'strength' },
      { exerciseId: 'ex-008', sets: 3, reps: 10, weightLbs: 45,  type: 'strength' },
      { exerciseId: 'ex-010', sets: 3, reps: 0,  weightLbs: 0, durationSec: 60, type: 'bodyweight' },
    ],
  },
  {
    id: 'wk-002',
    name: 'Upper Push Pull',
    description: 'Balanced upper body hypertrophy session.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-002', 'athlete-004'],
    scheduledDate: '2026-05-22',
    duration: 55,
    workOutputTarget: 2100,
    tags: ['hypertrophy', 'upper'],
    exercises: [
      { exerciseId: 'ex-002', sets: 4, reps: 8,  weightLbs: 135, type: 'strength' },
      { exerciseId: 'ex-004', sets: 4, reps: 6,  weightLbs: 0,   type: 'bodyweight' },
      { exerciseId: 'ex-005', sets: 3, reps: 10, weightLbs: 85,  type: 'strength' },
      { exerciseId: 'ex-007', sets: 3, reps: 12, weightLbs: 50,  type: 'strength' },
    ],
  },
  {
    id: 'wk-003',
    name: 'Conditioning Circuit',
    description: 'High-output metabolic conditioning.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-001', 'athlete-002', 'athlete-005'],
    scheduledDate: '2026-05-23',
    duration: 40,
    workOutputTarget: 1800,
    tags: ['conditioning', 'cardio'],
    exercises: [
      { exerciseId: 'ex-011', sets: 1, reps: 0, durationSec: 1200, type: 'cardio' },
      { exerciseId: 'ex-013', sets: 4, reps: 8, weightLbs: 0, type: 'bodyweight' },
      { exerciseId: 'ex-014', sets: 3, reps: 15, weightLbs: 35, type: 'mixed' },
    ],
  },
  {
    id: 'wk-004',
    name: 'Core & Mobility',
    description: 'Active recovery and core stability.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-001', 'athlete-003'],
    scheduledDate: '2026-05-26',
    duration: 35,
    workOutputTarget: 900,
    tags: ['recovery', 'core'],
    exercises: [
      { exerciseId: 'ex-010', sets: 4, reps: 0, durationSec: 60, type: 'bodyweight' },
      { exerciseId: 'ex-012', sets: 2, reps: 0, durationSec: 600, type: 'cardio' },
    ],
  },
  {
    id: 'wk-005',
    name: 'Deadlift Focus',
    description: 'Heavy hinge pattern day. Posterior chain emphasis.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-002', 'athlete-005'],
    scheduledDate: '2026-05-28',
    duration: 65,
    workOutputTarget: 2800,
    tags: ['strength', 'posterior'],
    exercises: [
      { exerciseId: 'ex-003', sets: 5, reps: 3, weightLbs: 225, type: 'strength' },
      { exerciseId: 'ex-006', sets: 3, reps: 8, weightLbs: 135, type: 'strength' },
      { exerciseId: 'ex-014', sets: 3, reps: 12, weightLbs: 53, type: 'mixed' },
    ],
  },
  {
    id: 'wk-006',
    name: 'Sprint & Power',
    description: 'Speed development and explosive lower body.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-001', 'athlete-004'],
    scheduledDate: '2026-05-30',
    duration: 50,
    workOutputTarget: 2000,
    tags: ['speed', 'power'],
    exercises: [
      { exerciseId: 'ex-013', sets: 6, reps: 5, weightLbs: 0, type: 'bodyweight' },
      { exerciseId: 'ex-011', sets: 1, reps: 0, durationSec: 900, type: 'cardio' },
      { exerciseId: 'ex-016', sets: 3, reps: 10, weightLbs: 180, type: 'strength' },
    ],
  },
  {
    id: 'wk-007',
    name: 'Shoulder Stability',
    description: 'Rotator cuff and overhead pressing work.',
    createdBy: 'coach-001',
    assignedTo: ['athlete-003', 'athlete-005'],
    scheduledDate: '2026-06-02',
    duration: 45,
    workOutputTarget: 1600,
    tags: ['upper', 'shoulders'],
    exercises: [
      { exerciseId: 'ex-005', sets: 4, reps: 8, weightLbs: 75, type: 'strength' },
      { exerciseId: 'ex-018', sets: 4, reps: 15, weightLbs: 30, type: 'strength' },
      { exerciseId: 'ex-015', sets: 3, reps: 10, weightLbs: 0, type: 'bodyweight' },
    ],
  },
];

// ── Mock Workout Logs ─────────────────────────────────────────
export const MOCK_LOGS = [
  {
    id: 'log-001',
    workoutId: 'wk-001',
    athleteId: 'athlete-001',
    date: '2026-05-19',
    workOutputAchieved: 2310,
    workOutputTarget: 2400,
    notes: 'Felt strong. Back slightly tight on last set of RDL.',
    completed: true,
  },
  {
    id: 'log-002',
    workoutId: 'wk-002',
    athleteId: 'athlete-002',
    date: '2026-05-18',
    workOutputAchieved: 1950,
    workOutputTarget: 2100,
    notes: '',
    completed: true,
  },
  {
    id: 'log-003',
    workoutId: 'wk-003',
    athleteId: 'athlete-001',
    date: '2026-05-17',
    workOutputAchieved: 1820,
    workOutputTarget: 1800,
    notes: 'Exceeded target. Good cardio day.',
    completed: true,
  },
];

// ── Mock Social Feed Items ────────────────────────────────────
export const MOCK_FEED = [
  { id: 'feed-001', type: 'pr',     athleteId: 'athlete-003', text: 'Morgan Kim hit a new PR — Deadlift 245 lbs', timestamp: '2026-05-20T08:32:00Z', workOutput: 412, likes: 14, dislikes: 0 },
  { id: 'feed-002', type: 'log',    athleteId: 'athlete-001', text: 'Jordan Lee completed Lower Body Power — 2,310 WU', timestamp: '2026-05-19T17:14:00Z', workOutput: 2310, likes: 7, dislikes: 0 },
  { id: 'feed-003', type: 'video',  athleteId: 'athlete-001', text: 'Morning warm-up routine — 5 min flow', duration: '0:32', gradient: 'linear-gradient(135deg, #1e3a5f 0%, #0f766e 100%)', timestamp: '2026-05-20T07:15:00Z', likes: 21, dislikes: 1 },
  { id: 'feed-004', type: 'streak', athleteId: 'athlete-003', text: 'Morgan Kim is on a 12-day training streak', timestamp: '2026-05-19T09:00:00Z', workOutput: null, likes: 9, dislikes: 0 },
  { id: 'feed-005', type: 'video',  athleteId: 'athlete-002', text: 'Box jump form check — 3 sets of 8 at 24" box', duration: '1:14', gradient: 'linear-gradient(135deg, #4c1d95 0%, #be185d 100%)', timestamp: '2026-05-19T12:30:00Z', likes: 18, dislikes: 2 },
  { id: 'feed-006', type: 'log',    athleteId: 'athlete-002', text: 'Sam Torres completed Upper Push Pull — 1,950 WU', timestamp: '2026-05-18T16:45:00Z', workOutput: 1950, likes: 5, dislikes: 0 },
  { id: 'feed-007', type: 'video',  athleteId: 'athlete-003', text: 'PR attempt — 245 lb deadlift. New personal best.', duration: '0:48', gradient: 'linear-gradient(135deg, #7c2d12 0%, #92400e 50%, #ca8a04 100%)', timestamp: '2026-05-19T10:00:00Z', likes: 33, dislikes: 0 },
  { id: 'feed-008', type: 'assign', athleteId: 'athlete-004', text: 'New workout assigned: Conditioning Circuit', timestamp: '2026-05-18T11:00:00Z', workOutput: null, likes: 2, dislikes: 0 },
  { id: 'feed-009', type: 'pr',     athleteId: 'athlete-005', text: 'Riley Chen hit a new PR — Bench Press 185 lbs', timestamp: '2026-05-17T15:22:00Z', workOutput: 628, likes: 11, dislikes: 0 },
];

// ── Helper: get exercise by ID ────────────────────────────────
export function getExerciseById(id) {
  return EXERCISE_LIBRARY.find((ex) => ex.id === id) || null;
}

// ── Helper: get athlete by ID ─────────────────────────────────
export function getAthleteById(id) {
  return MOCK_ATHLETES.find((a) => a.id === id) || null;
}

// ── Helper: get workouts assigned to athlete ──────────────────
export function getWorkoutsForAthlete(athleteId) {
  return MOCK_WORKOUTS.filter((w) => w.assignedTo.includes(athleteId));
}

// ── Helper: get logs for athlete ──────────────────────────────
export function getLogsForAthlete(athleteId) {
  return MOCK_LOGS.filter((l) => l.athleteId === athleteId);
}

// ── Coach lookup ──────────────────────────────────────────────
export const MOCK_COACHES = {
  'coach-001': { id: 'coach-001', name: 'Alex Rivera', specialty: 'Strength & Conditioning' },
};

// ── Radar chart scores (0–1 per axis) ────────────────────────
export const MOCK_RADAR_SCORES = {
  'athlete-001': {
    Jump: 0.72, Squat: 0.85, Lateral: 0.60, Hinge: 0.78,
    Carry: 0.55, Core: 0.90, Rotation: 0.65,
    'Horiz. Push': 0.80, 'Vert. Push': 0.70,
    'Horiz. Pull': 0.75, 'Vert. Pull': 0.68, Shoulder: 0.60,
  },
  team: {
    Jump: 0.68, Squat: 0.74, Lateral: 0.58, Hinge: 0.72,
    Carry: 0.63, Core: 0.80, Rotation: 0.61,
    'Horiz. Push': 0.76, 'Vert. Push': 0.65,
    'Horiz. Pull': 0.71, 'Vert. Pull': 0.64, Shoulder: 0.59,
  },
};

// ── Training Blocks ───────────────────────────────────────────
export const MOCK_TRAINING_BLOCKS = [
  {
    id: 'tb-001',
    name: 'Foundation Block',
    description: '8-week base building phase. Emphasis on movement quality, consistent volume, and establishing strong habits across the full team.',
    startDate: '2026-05-01',
    endDate: '2026-06-26',
    phase: 'Base',
    weekCount: 8,
    workoutIds: ['wk-001', 'wk-002', 'wk-003', 'wk-004', 'wk-005', 'wk-006', 'wk-today'],
  },
  {
    id: 'tb-002',
    name: 'Power Phase',
    description: '4-week explosive output block. Increased intensity, speed work, and high-load strength sessions.',
    startDate: '2026-06-27',
    endDate: '2026-07-24',
    phase: 'Power',
    weekCount: 4,
    workoutIds: ['wk-007'],
  },
];

// ── Initial comments ──────────────────────────────────────────
export const MOCK_COMMENTS = {
  'feed-001': [
    { id: 'c-001', author: 'Sam Torres',  text: 'Absolute beast. 245 is no joke!',        timestamp: '2026-05-20T09:12:00Z', likes: 5, userLiked: false },
    { id: 'c-002', author: 'Riley Chen',  text: 'Goals. What program are you running?',   timestamp: '2026-05-20T10:05:00Z', likes: 2, userLiked: false },
  ],
  'feed-003': [
    { id: 'c-003', author: 'Morgan Kim',  text: 'Love the flow, what mat is that?',        timestamp: '2026-05-20T08:00:00Z', likes: 3, userLiked: false },
  ],
  'feed-007': [
    { id: 'c-004', author: 'Casey Patel', text: 'Insane pull. Lock those lats in!',         timestamp: '2026-05-19T11:00:00Z', likes: 4, userLiked: false },
    { id: 'c-005', author: 'Jordan Lee',  text: 'That bar speed on the way up 🔥',          timestamp: '2026-05-19T11:30:00Z', likes: 7, userLiked: false },
  ],
  'feed-009': [
    { id: 'c-006', author: 'Sam Torres',  text: 'Welcome to the 185 club!',                 timestamp: '2026-05-17T16:00:00Z', likes: 6, userLiked: false },
  ],
};
